import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { Navigation } from "./types.js";
addProp(_Web, "navigation", Navigation);
//# sourceMappingURL=web.js.map